import { render } from "./LocationImport.vue?vue&type=template&id=6f57dd8d"
import script from "./LocationImport.vue?vue&type=script&lang=ts"
export * from "./LocationImport.vue?vue&type=script&lang=ts"
script.render = render

export default script